import { AxiosError } from "axios";
import { RetailMatchGeographyOption } from "../../../Enums/RetailMatchGeographyOption";
import { ILatLon } from "../../../Models/ILatLon";
import { IRetailMatchJob } from "../../../Models/IRetailMatch";
import { IRetailMatchGeography } from "../../../Models/IRetailMatchGeography";
import { ISubmitRetailMatchJobRequest } from "../../../Models/Requests/ISubmitRetailMatchJobRequest";
import { MatchReportTypeEnum } from "../Enums/MatchReportTypeEnum";
import * as types from "../Types/RetailMatchActionTypes";

/** misc */
export const setLoadingRetailMatchGeographies = (
    loading: boolean,
): types.SetLoadingRetailMatchGeographiesAction => ({
    type: types.SET_LOADING_RETAIL_MATCH_GEOGRAPHIES,
    data: loading,
});
export const setMostRecentlySubmittedRetailMatchReport = (
    report: IRetailMatchJob | null,
): types.SetMostRecentlySubmittedMobilyticsReportAction => ({
    type: types.SET_MOST_RECENTLY_SUBMITTED_RETAIL_MATCH_REPORT,
    data: report,
});

export const setLoadingMatchReport = (
    loading: boolean,
): types.SetLoadingMatchReportAction => ({
    type: types.SET_LOADING_MATCH_REPORT,
    data: loading,
});

/** initiate */
export const getRetailMatchGeographiesInitiate = (
    option: RetailMatchGeographyOption,
): types.GetRetailMatchGeographiesInitiateAction => ({
    type: types.GET_RETAIL_MATCH_GEOGRAPHIES_INITIATE,
    data: option,
});

export const submitMatchReportInitiate = (
    request: ISubmitRetailMatchJobRequest,
): types.SubmitMatchReportIniitiateAction => ({
    type: types.SUBMIT_MATCH_REPORT_INITIATE,
    data: request,
});

/** success */
export const getRetailMatchGeographiesSuccess = (
    geos: IRetailMatchGeography[],
): types.GetRetailMatchGeographiesSuccessAction => ({
    type: types.GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS,
    data: geos,
});

export const submitMatchReportSuccess = (job: IRetailMatchJob): types.SubmitMatchReportSuccessAction => ({
    type: types.SUBMIT_MATCH_REPORT_SUCCESS,
    data: job,
});

/** failure */
export const getRetailMatchGeographiesFailure = (
    error: AxiosError,
): types.GetRetailMatchGeographiesFailureAction => ({
    type: types.GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE,
    data: error.message,
});

export const submitMatchReportFailure = (
    error: AxiosError,
): types.SubmitMatchReportFailureAction => ({
    type: types.SUBMIT_MATCH_REPORT_FAILURE,
    data: error.message,
});

export const setSearchedMatchPlace = (
    name: string,
    placeId: string,
    lat: number,
    lng: number,
): types.SetSearchedPlaceMatchAction => ({
    type: types.SET_SEARCHED_PLACE_MATCH_ACTION,
    data: {
        name,
        placeId,
        lat,
        lng,
    },
});

export const setMatchReportType = (
    reportType: MatchReportTypeEnum,
): types.SetRetailMatchReportTypeAction => ({
    type: types.SET_MATCH_REPORT_TYPE,
    data: reportType,
});

export const startLastReportRunning = (
    reportName: string,
): types.StartLastReportRunningAction => ({
    type: types.START_LAST_REPORT_RUNNING,
    data: reportName,
});

export const ignoreRunningReport = (
    reportName: string,
) : types.IgnoreRunningReportAction => ({
    type: types.IGNORE_RUNNING_REPORT,
    data: reportName,
});

export const resetRetailMatch = (
    ignore: number,
) : types.ResetRetailMatchAction => ({
    type: types.RESET_RETAIL_MATCH_ACTION,
    data: ignore,
});

export const restartRetailMatch = () : types.RestartRetailMatch => ({
    type: types.RESTART_RETAIL_MATCH_ACTION, 
    data: null
});

export const setIncludeAllBuds = (
    includeAll: boolean,
): types.SetIncludeAllBudsAction => ({
    type: types.SET_INCLUDE_ALL_BUDS_ACTION,
    data: includeAll,
});

export const siteIsInDMAInitiate = (data: ILatLon): types.SiteIsInDMAInitiateAction => ({
    type: types.SITE_IS_IN_DMA_INITIATE,
    data: data,
});

export const siteIsInDMASuccess = (data: boolean): types.SiteIsInDMASuccessAction => ({
    type: types.SITE_IS_IN_DMA_SUCCESS,
    data: data,
});

export const siteIsInDMAFailure = (data: string): types.SiteIsInDMAFailureAction => ({
    type: types.SITE_IS_IN_DMA_FAILURE,
    data: data,
});

export const setCheckingtSiteIsInDMA = (data: boolean): types.CheckingSiteIsInDMAAction => ({
    type: types.SET_CHECKING_SITE_IS_IN_DMA,
    data: data,
});